import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { MOBILE } from '../../../guided-toolbox/utils/breakpoints'

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap-reverse;
  gap: 16px;
  padding: 1.75rem 0;
  ${p =>
    p.shrink &&
    css`
      margin: 0 auto;
      max-width: 800px;
    `};

  ${MOBILE} {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    align-items: stretch;
  }
`

const IndentContainer = styled.div`
  padding-left: 36px;
`

export { ButtonGroup, IndentContainer }
